import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { unwrap as e } from "../../../core/maybe.js";
import { f as t, k as r, u as i, v as o } from "../../../chunks/vec2.js";
import { a as s, f as n } from "../../../chunks/vec2f64.js";
import { SnappingAlgorithm as p } from "./SnappingAlgorithm.js";
import { RayConstraint as g } from "./SnappingConstraint.js";
import { anyMapPointToScreenPoint as h, squareDistance as a } from "./snappingUtils.js";
import { RightAngleSnappingCandidate as d } from "./candidates/RightAngleSnappingCandidate.js";

var c = /*#__PURE__*/function (_p) {
  _inherits(c, _p);

  var _super = _createSuper(c);

  function c() {
    var _this;

    _classCallCheck(this, c);

    _this = _super.apply(this, arguments), _this._tmp = s();
    return _this;
  }

  _createClass(c, [{
    key: "snapNewVertex",
    value: function snapNewVertex(e, t) {
      var r = t.editGeometryOperations.data.components[0],
          i = r.vertices.length,
          o = [];
      if (i < 2) return o;
      var s = h(e, t.coordinateHelper, t.elevationInfo, this.view),
          n = r.vertices[i - 1];

      this._checkForSnappingCandidate(o, n.leftEdge, n.pos, e, n.leftEdge.leftVertex.pos, n.pos, t, e, s);

      var p = r.vertices[0];
      return this._checkForSnappingCandidate(o, p.rightEdge, p.pos, e, p.rightEdge.rightVertex.pos, p.pos, t, e, s), o;
    }
  }, {
    key: "snapExistingVertex",
    value: function snapExistingVertex(t, r) {
      var i = [],
          o = e(r.vertexHandle),
          s = o.component,
          n = s.vertices.length;
      if (n < 3) return i;
      var p = h(t, r.coordinateHelper, r.elevationInfo, this.view),
          g = o.leftEdge,
          a = o.rightEdge,
          d = s.vertices[0],
          _c = s.vertices[n - 1];
      if (!g) return this._checkForSnappingCandidate(i, d.rightEdge.rightVertex.rightEdge, d.rightEdge.rightVertex.pos, t, d.rightEdge.rightVertex.rightEdge.rightVertex.pos, d.rightEdge.rightVertex.pos, r, t, p), i;
      if (!a) return this._checkForSnappingCandidate(i, _c.leftEdge.leftVertex.leftEdge, _c.leftEdge.leftVertex.pos, t, _c.leftEdge.leftVertex.leftEdge.leftVertex.pos, _c.leftEdge.leftVertex.pos, r, t, p), i;

      if (g && g.leftVertex.leftEdge) {
        var _e = g.leftVertex.leftEdge;

        this._checkForSnappingCandidate(i, _e, g.leftVertex.pos, t, _e.leftVertex.pos, g.leftVertex.pos, r, t, p);
      }

      if (a && a.rightVertex.rightEdge) {
        var _e2 = a.rightVertex.rightEdge;

        this._checkForSnappingCandidate(i, _e2, a.rightVertex.pos, t, _e2.rightVertex.pos, a.rightVertex.pos, r, t, p);
      }

      return i;
    }
  }, {
    key: "_checkForSnappingCandidate",
    value: function _checkForSnappingCandidate(e, p, _c2, f, l, x, V, m, E) {
      if (!this.edgeExceedsShortLineThreshold(p, V)) return;
      t(this._tmp, p.rightVertex.pos, p.leftVertex.pos);

      var v = n(this._tmp[1], -this._tmp[0]),
          u = r(v, t(this._tmp, f, _c2)) / i(v),
          _ = V.coordinateHelper,
          S = _.fromXYZ(o(s(), x, v, u), _.getZ(m, 0));

      a(E, h(S, _, V.elevationInfo, this.view)) < this.squaredProximityTreshold(V.pointer) && e.push(new d({
        coordinateHelper: _,
        targetPoint: S,
        constraint: new g(_, x, o(_.createVector(), x, v, Math.sign(u))),
        previousVertex: l,
        otherVertex: x,
        otherVertexType: 1
      }));
    }
  }]);

  return c;
}(p);

export { c as RightAngleSnapper };